import { Mail, MessageSquare, MapPin, Clock } from "lucide-react";
import LegalPage from "@/pages/legal/LegalPage";

export default function ContactUs() {
  return (
    <LegalPage title="Contact Us" testId="page-contact">
      <p>
        We&apos;re a small team building LeadGen for small-business owners. If you have a question, a bug report, a
        feature idea, a partnership proposal, or need help with a plan you&apos;ve generated, we&apos;d love to hear
        from you.
      </p>

      <div className="not-prose grid sm:grid-cols-2 gap-4 mt-8">
        <div className="border border-zinc-200 rounded-2xl p-5" data-testid="contact-email">
          <Mail className="h-5 w-5 text-indigo-600" />
          <div className="text-xs uppercase tracking-widest text-zinc-500 mt-3">Email</div>
          <a href="mailto:madwithppc@gmail.com" className="font-display font-black text-xl text-zinc-900 mt-1 block">
            madwithppc@gmail.com
          </a>
          <p className="text-sm text-zinc-600 mt-2">General questions, feedback and partnerships.</p>
        </div>

        <div className="border border-zinc-200 rounded-2xl p-5" data-testid="contact-support">
          <MessageSquare className="h-5 w-5 text-indigo-600" />
          <div className="text-xs uppercase tracking-widest text-zinc-500 mt-3">Support</div>
          <a href="mailto:support@madwithppc.com" className="font-display font-black text-xl text-zinc-900 mt-1 block">
            support@madwithppc.com
          </a>
          <p className="text-sm text-zinc-600 mt-2">Issues with a plan, payment or your account.</p>
        </div>

        <div className="border border-zinc-200 rounded-2xl p-5" data-testid="contact-hours">
          <Clock className="h-5 w-5 text-indigo-600" />
          <div className="text-xs uppercase tracking-widest text-zinc-500 mt-3">Hours</div>
          <div className="font-display font-black text-xl text-zinc-900 mt-1">Mon-Fri · 10am-7pm IST</div>
          <p className="text-sm text-zinc-600 mt-2">We respond to most emails within one business day.</p>
        </div>

        <div className="border border-zinc-200 rounded-2xl p-5" data-testid="contact-address">
          <MapPin className="h-5 w-5 text-indigo-600" />
          <div className="text-xs uppercase tracking-widest text-zinc-500 mt-3">Registered address</div>
          <div className="font-display font-black text-xl text-zinc-900 mt-1 leading-snug">India</div>
          <p className="text-sm text-zinc-600 mt-2">
            Full postal address will be added once business registration is finalised.
          </p>
        </div>
      </div>

      <h2>Before you write to us</h2>
      <p>
        Many questions can be answered on the{" "}
        <a href="/#pricing">Pricing</a> page or in our Terms &amp; Conditions, Cancellation &amp; Refunds, and
        Privacy Policy pages linked in the footer.
      </p>
    </LegalPage>
  );
}
